import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsIconRegistry,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';
import { mdiLoupe, mdiPencil } from '@mdi/js';

import { CmpsFocusItemComponent } from './focus-item.component';

@NgModule({
    declarations: [CmpsFocusItemComponent],
    imports: [
        CommonModule,
        CmpsIconModule,
        CmpsButtonModule,
        CmpsTooltipModule,
    ],
    exports: [CmpsFocusItemComponent],
})
export class CmpsFocusItemModule {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [
            ['pencil', mdiPencil],
            ['loupe', mdiLoupe],
        ].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}"><path d="${icon}"></path></svg>`,
                ),
                '__internal',
            );
        });
    }
}
